import { render, staticRenderFns } from "./SingInPage.vue?vue&type=template&id=5b955ecc&"
import script from "./SingInPage.vue?vue&type=script&lang=js&"
export * from "./SingInPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports